import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { routes } from './app.routes';
import { environment } from '../environments/environment';

import { SharedModule } from './components/shared/shared.module';

import { AppComponent } from './app.component';
import { Storyboard3dComponent } from "./components/storyboard3d/storyboard3d.component";
import { HomeComponent } from './components/home/home.component';
import { CustomModelGeneratorComponent } from "./components/custom-model-generator/custom-model-generator.component";

import { StoryboardGeneratorComponent } from "./components/storyboard-generator/storyboard-generator.component";
import { VisualNarrativeMakerComponent } from "./components/visual-narrative-maker/visual-narrative-maker.component";

@NgModule({
    declarations: [
        AppComponent,
        Storyboard3dComponent,
        HomeComponent,
        CustomModelGeneratorComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot(routes),
        SharedModule,
        StoryboardGeneratorComponent,
        VisualNarrativeMakerComponent
    ],
    providers: [
        provideHttpClient(),
        provideAuth({
            config: {
                authority: environment.cognito.authority,
                redirectUrl: window.location.origin,
                postLogoutRedirectUri: new URL(environment.pvfTopUrl).origin,
                clientId: environment.cognito.clientId,
                scope: environment.cognito.scope,
                responseType: 'code',
                silentRenew: true,
                useRefreshToken: true
            }
        }, withAppInitializerAuthCheck())
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
